var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExchangeGiftIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2605 15.4785V28.9568H4.69531V15.4785",
    stroke: "#2EC2E6",
    strokeWidth: 2.69565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9565 8.73926H2V15.4784H28.9565V8.73926Z",
    stroke: "#2EC2E6",
    strokeWidth: 2.69565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4766 28.9566V8.73926",
    stroke: "#2EC2E6",
    strokeWidth: 2.69565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4817 8.73913H9.41644C8.52278 8.73913 7.66571 8.38412 7.0338 7.75221C6.40188 7.12029 6.04688 6.26323 6.04688 5.36957C6.04688 4.4759 6.40188 3.61884 7.0338 2.98692C7.66571 2.35501 8.52278 2 9.41644 2C14.1338 2 15.4817 8.73913 15.4817 8.73913Z",
    stroke: "#2EC2E6",
    strokeWidth: 2.69565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4766 8.73913H21.5418C22.4354 8.73913 23.2925 8.38412 23.9244 7.75221C24.5563 7.12029 24.9113 6.26323 24.9113 5.36957C24.9113 4.4759 24.5563 3.61884 23.9244 2.98692C23.2925 2.35501 22.4354 2 21.5418 2C16.8244 2 15.4766 8.73913 15.4766 8.73913Z",
    stroke: "#2EC2E6",
    strokeWidth: 2.69565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeGiftIcon);
export default __webpack_public_path__ + "static/media/exchange-gift-icon.e4460946e91792f0ad724946c4603b72.svg";
export { ForwardRef as ReactComponent };